import SingleToolFooter from '@quicktools/shared-components/components/common/SingleToolFooter/SingleToolFooter';
import { ImageWithTextSection } from '@quicktools/shared-components/components/landingPages/ImageWithTextSection';
import { useTranslation } from 'react-i18next';
import { memo } from 'react';

import analytics from '../../services/analytics';
import SimilarTools from '../SimilarTools';

import { ICategoryContentProps } from './types';

function CategoryContent({ imgs, category }: ICategoryContentProps) {
  const { t } = useTranslation();

  return (
    <>
      {imgs.map(({ url, width }, i) => {
        const baseKey = `categories.${category}.sections.${i}`;
        const title = t(`${baseKey}.title`);
        const description = t(`${baseKey}.description`);
        const imageRight = !(i % 2);

        return (
          <ImageWithTextSection
            key={url}
            imgSrc={url}
            imgAlt=""
            imageWidth={width}
            title={title}
            description={description}
            imageRight={imageRight}
          />
        );
      })}

      <SimilarTools />

      <SingleToolFooter analytics={analytics} />
    </>
  );
}

export default memo(CategoryContent);
